import { memo } from "react";

import { tickYellowIcon } from "../assets/images";
import { WhatsappButton } from "../components/ui/button";

// Completed form display component
const CompletedForm = memo(({ restaurantData }) => {
  return (
    <div className="flex flex-col items-center justify-center w-full p-8 lg:h-full h-[calc(100vh-200px)]">
      <div className="flex flex-col items-center justify-center gap-2 max-w-md h-full">
        <div className="flex flex-col items-center justify-end gap-2 w-full h-1/2">
          <img src={tickYellowIcon} alt="tick" className="w-32 md:w-48" />
        </div>
        <div className="flex flex-col items-center justify-between gap-2 w-full h-1/2">
          <div className="flex flex-col items-center justify-center gap-2 w-full">
            <h2 className="text-2xl font-bold text-center text-neutralStrongBlack">
              ¡Listo! Recibimos tu información{" "}
            </h2>

            <>
              {!restaurantData?.region ? (
                <>
                  <span className="text-neutralDarkBlack text-center font-medium text-lg block">
                    Lamentablemente Morfy no se encuentra en su región. Estamos
                    continuamente trabajando para expandir nuestra cobertura.
                  </span>
                  <span className="text-neutralDarkBlack text-center font-medium text-lg block">
                    Te contactaremos pronto.
                  </span>
                </>
              ) : (
                <span className="text-neutralDarkBlack text-center font-medium text-lg block">
                  Te contactaremos pronto para continuar con el proceso de
                  incorporación.{" "}
                </span>
              )}
            </>
          </div>

          <div className="flex flex-col items-center justify-end gap-2 py-8">
            <WhatsappButton text="¿Dudas? Chatea con nosotros" />
          </div>
        </div>
      </div>
    </div>
  );
});
CompletedForm.displayName = "CompletedForm";

export default CompletedForm;
